'use client'

import { createContext, useCallback, useContext, useState } from 'react'
import type { ReactNode } from 'react'
import { Backdrop } from '@/CommonComponents'

// Define types for BackdropContext and BackdropProvider props
export interface IBackdropContextType {
  (show: boolean): void
}

interface IBackdropProviderProps {
  children: ReactNode
}

const backdropContext = createContext<IBackdropContextType | undefined>(undefined)

export function BackdropProvider({ children }: IBackdropProviderProps) {
  const [isOpenBackdrop, setisOpenBackdrop] = useState(false)

  const showBackdrop = useCallback<IBackdropContextType>((show) => {
    setisOpenBackdrop(show)
  }, [])

  return (
    <backdropContext.Provider value={showBackdrop}>
      {children}
      <Backdrop open={isOpenBackdrop} />
    </backdropContext.Provider>
  )
}

export const useBackdrop = (): IBackdropContextType => {
  const context = useContext(backdropContext)
  if (!context) {
    throw new Error('useBackdrop must be used within a BackdropProvider')
  }
  return context
}
